/**
 * Author: SCS (Santosh Chandra Shekhar)
 * ***scs***
 */

import React, { useContext, useState, useEffect, useRef } from "react";
import { themeContext } from "../../Context";
import "./Experience.css";

const Counter = ({ target, darkMode, inView }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) {
      setCount(0);
      return;
    }

    let start = 0;
    const duration = 2000; // 2 seconds
    const increment = target / (duration / 50); // Update every 50ms

    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 50);

    return () => clearInterval(timer);
  }, [target, inView]);

  return (
    <div className="circle" style={{color: darkMode?'var(--orange)':''}}>
      {count}+
    </div>
  );
};

const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const [inView, setInView] = useState(false);
  const experienceRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (experienceRef.current) {
      observer.observe(experienceRef.current);
    }

    return () => {
      if (experienceRef.current) {
        observer.unobserve(experienceRef.current);
      }
    };
  }, []);

  return (
    <div className="experience" id='experience' ref={experienceRef}>
      <div className="achievement">
        {/* darkMode */}
        <Counter target={7} darkMode={darkMode} inView={inView} />
        <span  style={{color: darkMode?'white':''}}>years </span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <Counter target={21} darkMode={darkMode} inView={inView} />
        <span  style={{color: darkMode?'white':''}}>completed </span>
        <span>Projects</span>
      </div>
      <div className="achievement">
        <Counter target={5} darkMode={darkMode} inView={inView} />
        <span  style={{color: darkMode?'white':''}}>companies </span>
        <span>Work</span>
      </div>
    </div>
  );
};

export default Experience;
